import React, { useState, useRef } from 'react';
import api from '../services/api';
import './TemplateIntelligenceModule.css';

const TABS = [
  { id: 'overview',   label: 'Overview',         icon: 'overview' },
  { id: 'upload',     label: 'Upload Template',   icon: 'upload'   },
  { id: 'database',   label: 'Database',          icon: 'database' },
  { id: 'test-match', label: 'Test Pattern Match',icon: 'test'     },
  { id: 'config',     label: 'Configuration',     icon: 'config'   },
];

function TabIcon({ id }) {
  const icons = {
    overview: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
      </svg>
    ),
    upload: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/>
        <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
      </svg>
    ),
    database: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4.03 3-9 3S3 13.66 3 12"/>
        <path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5"/>
      </svg>
    ),
    test: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
      </svg>
    ),
    config: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.07 4.93l-1.41 1.41M5.34 18.66l-1.41 1.41M20 12h-2M6 12H4M19.07 19.07l-1.41-1.41M5.34 5.34L3.93 3.93M12 20v-2M12 6V4"/>
      </svg>
    ),
  };
  return icons[id] || null;
}

/* ================================================================
   OVERVIEW TAB
   ================================================================ */
function OverviewTab({ stats, onGoToUpload }) {
  const total    = stats?.total_templates ?? 0;
  const vendors  = stats?.vendors ?? [];
  const algorithm  = stats?.matching_algorithm ?? 'N/A';
  const threshold  = stats?.similarity_threshold ?? 0;
  const hasTemplates = total > 0;

  return (
    <div className="ti-content">
      <div className="ti-stats-grid">
        <div className="ti-stat-card">
          <div className="ti-stat-icon purple">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </div>
          <div className="ti-stat-val">{total}</div>
          <div className="ti-stat-lbl">Templates</div>
        </div>
        <div className="ti-stat-card">
          <div className="ti-stat-icon blue">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </div>
          <div className="ti-stat-val">{vendors.length}</div>
          <div className="ti-stat-lbl">Vendors</div>
        </div>
        <div className="ti-stat-card">
          <div className={`ti-stat-icon ${hasTemplates ? 'green' : 'muted'}`}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              {hasTemplates
                ? <><polyline points="20 6 9 17 4 12"/></>
                : <><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></>}
            </svg>
          </div>
          <div className="ti-stat-val" style={{ color: hasTemplates ? '#22c55e' : '#4a4a6a' }}>
            {hasTemplates ? 'ACTIVE' : 'IDLE'}
          </div>
          <div className="ti-stat-lbl">Engine</div>
        </div>
        <div className="ti-stat-card">
          <div className="ti-stat-icon amber">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
              <line x1="6" y1="20" x2="6" y2="14"/>
            </svg>
          </div>
          <div className="ti-stat-val">{(threshold * 100).toFixed(0)}%</div>
          <div className="ti-stat-lbl">Threshold</div>
        </div>
      </div>

      {hasTemplates ? (
        <>
          <div className="ti-section">
            <div className="ti-section-head">
              <span className="ti-section-title">Known Vendors</span>
              <span className="ti-count-chip">{vendors.length}</span>
            </div>
            <div className="ti-vendor-table">
              {[...vendors].sort((a, b) => b.count - a.count).map((v, i) => (
                <div key={i} className="ti-vendor-row">
                  <div className="ti-vendor-dot" />
                  <span className="ti-vendor-name">{v.name}</span>
                  <span className="ti-vendor-count">{v.count} template{v.count !== 1 ? 's' : ''}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="ti-section">
            <div className="ti-section-head">
              <span className="ti-section-title">Active Algorithm</span>
            </div>
            <div className="ti-algo-badge-row">
              <div className="ti-algo-badge">{algorithm}</div>
              <div className="ti-algo-threshold">Similarity threshold: <strong>{(threshold * 100).toFixed(0)}%</strong></div>
            </div>
          </div>
        </>
      ) : (
        <div className="ti-empty-state">
          <div className="ti-empty-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(124,92,252,0.4)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </div>
          <h3 className="ti-empty-title">No templates stored yet</h3>
          <p className="ti-empty-desc">Upload your first invoice template to enable pattern-based fraud detection. Once stored, every analysis will compare against your template library.</p>
          <button className="ti-primary-btn" onClick={onGoToUpload}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/>
              <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
            </svg>
            Upload First Template
          </button>
        </div>
      )}
    </div>
  );
}

/* ================================================================
   UPLOAD TAB
   ================================================================ */
function UploadTab({ onUploadSuccess }) {
  const [file,       setFile]       = useState(null);
  const [vendorName, setVendorName] = useState('');
  const [notes,      setNotes]      = useState('');
  const [dragging,   setDragging]   = useState(false);
  const [loading,    setLoading]    = useState(false);
  const [success,    setSuccess]    = useState(null);
  const [error,      setError]      = useState(null);
  const fileRef = useRef();

  const handleFile = (f) => {
    if (!f) return;
    setFile(f); setSuccess(null); setError(null);
  };

  const handleSubmit = async () => {
    if (!file || !vendorName.trim()) return;
    setLoading(true); setError(null);
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('vendor_name', vendorName.trim());
      if (notes.trim()) fd.append('notes', notes.trim());
      await api.post('/store-template', fd);
      const saved = vendorName.trim();
      setSuccess(saved); setFile(null); setVendorName(''); setNotes('');
      onUploadSuccess();
    } catch (e) {
      setError(e.response?.data?.detail || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="ti-content">
      <div className="ti-upload-layout">
        {/* Left: dropzone */}
        <div className="ti-upload-left">
          <label className="ti-field-label">Template Invoice File</label>
          <div
            className={`ti-dropzone ${dragging ? 'dragging' : ''} ${file ? 'has-file' : ''}`}
            onDragOver={e => { e.preventDefault(); setDragging(true); }}
            onDragLeave={() => setDragging(false)}
            onDrop={e => { e.preventDefault(); setDragging(false); handleFile(e.dataTransfer.files[0]); }}
            onClick={() => fileRef.current?.click()}
          >
            {file ? (
              <div className="ti-file-chosen">
                <div className="ti-file-badge">
                  {file.type === 'application/pdf' ? 'PDF' : 'IMG'}
                </div>
                <div className="ti-file-chosen-name">{file.name}</div>
                <div className="ti-file-chosen-size">{(file.size / 1024).toFixed(1)} KB</div>
                <div className="ti-file-change">Click to change</div>
              </div>
            ) : (
              <div className="ti-drop-inner">
                <div className="ti-drop-upload-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgba(124,92,252,0.6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/>
                    <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
                  </svg>
                </div>
                <div className="ti-drop-title">Drop template here</div>
                <div className="ti-drop-sub">PDF, PNG, JPG, JPEG, TIFF</div>
              </div>
            )}
          </div>
          <input ref={fileRef} type="file" accept=".pdf,.png,.jpg,.jpeg,.tiff,.bmp,.webp"
            style={{ display: 'none' }} onChange={e => handleFile(e.target.files[0])} />
        </div>

        {/* Right: form */}
        <div className="ti-upload-right">
          <div className="ti-field-group">
            <label className="ti-field-label">
              Vendor Name <span className="ti-req">*</span>
            </label>
            <input className="ti-input" type="text" value={vendorName}
              onChange={e => setVendorName(e.target.value)}
              placeholder="e.g. Acme Corp, TechSupplies Ltd…" />
          </div>
          <div className="ti-field-group">
            <label className="ti-field-label">
              Notes <span className="ti-opt">(optional)</span>
            </label>
            <textarea className="ti-textarea" value={notes} rows={5}
              onChange={e => setNotes(e.target.value)}
              placeholder="Any additional context about this template…" />
          </div>
          <button
            className={`ti-primary-btn ${loading ? 'loading' : ''}`}
            onClick={handleSubmit}
            disabled={loading || !file || !vendorName.trim()}
            style={{ marginTop: 8 }}
          >
            {loading
              ? <><span className="ti-spinner" /> Storing template…</>
              : <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> Store Template</>}
          </button>
          {success && (
            <div className="ti-feedback success">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              Template stored for <strong>{success}</strong>
            </div>
          )}
          {error && (
            <div className="ti-feedback error">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              {error}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ================================================================
   DATABASE TAB
   ================================================================ */
function DatabaseTab({ stats, onRefresh }) {
  const total = stats?.total_templates ?? 0;
  const [templates, setTemplates] = useState(null);
  const [confirmId, setConfirmId] = useState(null);
  const [deleting,  setDeleting]  = useState(null);
  const [deleteErr, setDeleteErr] = useState(null);

  const fetchTemplates = React.useCallback(async () => {
    try {
      const resp = await api.get('/templates-list');
      setTemplates(resp.data.templates || []);
    } catch {
      setTemplates([]);
    }
  }, []);

  React.useEffect(() => { fetchTemplates(); }, [fetchTemplates]);

  const handleRefresh = () => { fetchTemplates(); onRefresh(); };

  const handleDelete = async (id) => {
    setDeleting(id);
    setDeleteErr(null);
    try {
      await api.delete(`/templates/${id}`);
      setTemplates(t => t.filter(x => x.id !== id));
      setConfirmId(null);
      onRefresh();
    } catch (e) {
      setDeleteErr(e.response?.data?.detail || e.message);
    } finally {
      setDeleting(null);
    }
  };

  const rows = templates ?? [];

  return (
    <div className="ti-content">
      <div className="ti-db-bar">
        <div className="ti-db-summary">
          <span className="ti-db-big">{total}</span>
          <span className="ti-db-unit">template{total !== 1 ? 's' : ''}</span>
        </div>
        <button className="ti-ghost-btn" onClick={handleRefresh}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
          </svg>
          Refresh
        </button>
      </div>

      {deleteErr && (
        <div className="ti-feedback error" style={{ marginBottom: 12 }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          {deleteErr}
        </div>
      )}

      {templates === null ? (
        <div style={{ color: '#6060a0', fontSize: 13, padding: '24px 0', textAlign: 'center' }}>Loading…</div>
      ) : rows.length > 0 ? (
        <div className="ti-table-wrap">
          <table className="ti-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Vendor</th>
                <th>Stored At</th>
                <th>Status</th>
                <th style={{ width: 90 }}></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((t) => (
                <tr key={t.id}>
                  <td><span style={{ fontFamily: 'monospace', color: '#6060a0', fontSize: 11 }}>#{t.id}</span></td>
                  <td>
                    <div className="ti-table-vendor">
                      <div className="ti-table-dot" />
                      <span>{t.vendor}</span>
                    </div>
                  </td>
                  <td style={{ fontSize: 11, color: '#6060a0' }}>{t.created_at ? t.created_at.split('T')[0] : '—'}</td>
                  <td><span className="ti-table-status active">Active</span></td>
                  <td>
                    {confirmId === t.id ? (
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button
                          className="ti-del-confirm-btn"
                          onClick={() => handleDelete(t.id)}
                          disabled={deleting === t.id}
                        >
                          {deleting === t.id ? '…' : 'Yes'}
                        </button>
                        <button className="ti-del-cancel-btn" onClick={() => setConfirmId(null)}>No</button>
                      </div>
                    ) : (
                      <button className="ti-del-btn" onClick={() => { setConfirmId(t.id); setDeleteErr(null); }}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/>
                          <path d="M9 6V4h6v2"/>
                        </svg>
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="ti-empty-state">
          <div className="ti-empty-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(124,92,252,0.4)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
              <ellipse cx="12" cy="5" rx="9" ry="3"/>
              <path d="M21 12c0 1.66-4.03 3-9 3S3 13.66 3 12"/>
              <path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5"/>
            </svg>
          </div>
          <h3 className="ti-empty-title">Database is empty</h3>
          <p className="ti-empty-desc">No templates have been stored yet. Use the Upload Template tab to add invoices to your database.</p>
        </div>
      )}
    </div>
  );
}

/* ================================================================
   TEST MATCH TAB
   ================================================================ */
function TestMatchTab() {
  const [mode,     setMode]     = useState('file');
  const [file,     setFile]     = useState(null);
  const [text,     setText]     = useState('');
  const [dragging, setDragging] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [result,   setResult]   = useState(null);
  const [error,    setError]    = useState(null);
  const fileRef = useRef();

  const handleFile = (f) => { setFile(f); setResult(null); setError(null); };

  const runTest = async () => {
    if (mode === 'file' && !file) return;
    if (mode === 'text' && !text.trim()) return;
    setLoading(true); setResult(null); setError(null);
    try {
      let resp;
      if (mode === 'file') {
        const fd = new FormData(); fd.append('file', file);
        resp = await api.post('/analyze', fd);
      } else {
        const fd = new FormData(); fd.append('invoice_text', text);
        resp = await api.post('/analyze-text', fd);
      }
      setResult(resp.data.result);
    } catch (e) {
      setError(e.response?.data?.detail || e.message);
    } finally { setLoading(false); }
  };

  const tmScore   = result?.template_match_score;
  const tmDetails = result?.template_details;
  const isMatch   = result?.is_template_match;
  const scoreColor = tmScore > 70 ? '#22c55e' : tmScore > 40 ? '#f59e0b' : '#ef4444';

  return (
    <div className="ti-content">
      {/* Mode Toggle */}
      <div className="ti-mode-toggle">
        <button className={`ti-mode-btn ${mode === 'file' ? 'active' : ''}`} onClick={() => setMode('file')}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/>
            <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
          </svg>
          Upload File
        </button>
        <button className={`ti-mode-btn ${mode === 'text' ? 'active' : ''}`} onClick={() => setMode('text')}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="17" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/>
            <line x1="21" y1="14" x2="3" y2="14"/><line x1="17" y1="18" x2="3" y2="18"/>
          </svg>
          Paste Text
        </button>
      </div>

      {mode === 'file' ? (
        <>
          <div
            className={`ti-dropzone sm ${dragging ? 'dragging' : ''} ${file ? 'has-file' : ''}`}
            onDragOver={e => { e.preventDefault(); setDragging(true); }}
            onDragLeave={() => setDragging(false)}
            onDrop={e => { e.preventDefault(); setDragging(false); handleFile(e.dataTransfer.files[0]); }}
            onClick={() => fileRef.current?.click()}
          >
            {file ? (
              <div className="ti-file-chosen">
                <div className="ti-file-badge">{file.type === 'application/pdf' ? 'PDF' : 'IMG'}</div>
                <div className="ti-file-chosen-name">{file.name}</div>
                <div className="ti-file-chosen-size">{(file.size / 1024).toFixed(1)} KB</div>
                <div className="ti-file-change">Click to change</div>
              </div>
            ) : (
              <div className="ti-drop-inner">
                <div className="ti-drop-upload-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgba(124,92,252,0.5)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/>
                    <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
                  </svg>
                </div>
                <div className="ti-drop-title" style={{ fontSize: 13 }}>Drop invoice to test</div>
                <div className="ti-drop-sub">PDF, PNG, JPG, JPEG</div>
              </div>
            )}
          </div>
          <input ref={fileRef} type="file" accept=".pdf,.png,.jpg,.jpeg,.tiff,.bmp,.webp"
            style={{ display: 'none' }} onChange={e => handleFile(e.target.files[0])} />
        </>
      ) : (
        <textarea className="ti-textarea" value={text} onChange={e => setText(e.target.value)}
          placeholder="Paste invoice text here…" rows={7} style={{ marginBottom: 0 }} />
      )}

      <button
        className={`ti-primary-btn ${loading ? 'loading' : ''}`}
        onClick={runTest}
        disabled={loading || (mode === 'file' ? !file : !text.trim())}
        style={{ maxWidth: 220, marginTop: 14 }}
      >
        {loading
          ? <><span className="ti-spinner" /> Running match…</>
          : <><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg> Run Pattern Match</>}
      </button>

      {error && (
        <div className="ti-feedback error" style={{ marginTop: 16 }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          {error}
        </div>
      )}

      {result && (
        <div className="ti-match-card">
          <div className="ti-match-top">
            <div className={`ti-match-verdict ${isMatch ? 'match' : 'nomatch'}`}>
              {isMatch
                ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                : <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>}
              {isMatch ? 'Pattern Match' : 'No Match / Unusual Pattern'}
            </div>
            {tmScore !== undefined && (
              <div className="ti-match-score-wrap">
                <span className="ti-match-score" style={{ color: scoreColor }}>{tmScore}%</span>
                <span className="ti-match-score-lbl">similarity</span>
              </div>
            )}
          </div>

          {tmScore !== undefined && (
            <div className="ti-progress-bar-wrap">
              <div className="ti-progress-bar">
                <div className="ti-progress-fill" style={{ width: `${tmScore}%`, background: `linear-gradient(90deg, ${scoreColor}aa, ${scoreColor})` }} />
              </div>
            </div>
          )}

          {tmDetails && (
            <div className="ti-match-details">
              {tmDetails.matched_vendor && (
                <div className="ti-detail-row">
                  <span className="ti-detail-key">Matched Vendor</span>
                  <span className="ti-detail-val">{tmDetails.matched_vendor}</span>
                </div>
              )}
              {tmDetails.match_type && (
                <div className="ti-detail-row">
                  <span className="ti-detail-key">Match Type</span>
                  <span className="ti-detail-val">{tmDetails.match_type}</span>
                </div>
              )}
              {result.risk_level && (
                <div className="ti-detail-row">
                  <span className="ti-detail-key">Findings</span>
                  <span className="ti-detail-val">
                    {(result.findings || []).length}
                  </span>
                </div>
              )}
              {tmDetails.message && (
                <div className="ti-detail-msg">{tmDetails.message}</div>
              )}
              {tmDetails.recommendation && (
                <div className="ti-detail-tip">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                  {tmDetails.recommendation}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

/* ================================================================
   CONFIG TAB
   ================================================================ */
function ConfigTab({ stats }) {
  const algorithm      = stats?.matching_algorithm ?? 'combined';
  const threshold      = stats?.similarity_threshold ?? 0.65;
  const matchThreshold = stats?.match_threshold ?? 0.70;
  const semWeight      = stats?.semantic_weight ?? 0.6;
  const structWeight   = stats?.structural_weight ?? 0.4;

  const configs = [
    {
      key: 'PATTERN_ALGORITHM',
      label: 'Pattern Algorithm',
      value: algorithm,
      desc: 'Options: combined · fuzzy · levenshtein · semantic',
      type: 'text',
    },
    {
      key: 'TEMPLATE_SIMILARITY_THRESHOLD',
      label: 'Similarity Threshold',
      value: threshold,
      desc: 'Minimum score to classify as a template match',
      type: 'bar',
    },
    {
      key: 'TEMPLATE_MATCH_THRESHOLD',
      label: 'Match Threshold',
      value: matchThreshold,
      desc: 'Threshold for template database matching',
      type: 'bar',
    },
    {
      key: 'SEMANTIC_SIMILARITY_WEIGHT',
      label: 'Semantic Weight',
      value: semWeight,
      desc: 'Semantic similarity weight in combined algorithm',
      type: 'bar',
    },
    {
      key: 'STRUCTURAL_SIMILARITY_WEIGHT',
      label: 'Structural Weight',
      value: structWeight,
      desc: 'Structural similarity weight in combined algorithm',
      type: 'bar',
    },
  ];

  return (
    <div className="ti-content">
      <div className="ti-config-notice">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
        Configuration is managed via <code>backend/.env</code>. Edit the file and restart the server to apply changes.
      </div>

      <div className="ti-config-grid">
        {configs.map(cfg => (
          <div key={cfg.key} className="ti-config-card">
            <div className="ti-config-card-label">{cfg.label}</div>
            {cfg.type === 'bar' ? (
              <>
                <div className="ti-config-card-val">{(cfg.value * 100).toFixed(0)}%</div>
                <div className="ti-config-mini-bar">
                  <div className="ti-config-mini-fill" style={{ width: `${cfg.value * 100}%` }} />
                </div>
              </>
            ) : (
              <div className="ti-config-card-val">{cfg.value}</div>
            )}
            <div className="ti-config-card-desc">{cfg.desc}</div>
            <code className="ti-config-env-key">{cfg.key}</code>
          </div>
        ))}
      </div>

      <div className="ti-config-howto">
        <div className="ti-config-howto-title">How to update</div>
        <ol className="ti-config-steps">
          <li>Open <code>backend/.env</code> in your editor</li>
          <li>Update the desired variable value</li>
          <li>Save the file and restart the backend server</li>
          <li>Refresh this page to see new config</li>
        </ol>
      </div>
    </div>
  );
}

/* ================================================================
   MAIN MODULE
   ================================================================ */
export default function TemplateIntelligenceModule({ stats, onRefreshStats }) {
  const [activeTab, setActiveTab] = useState('overview');
  const total = stats?.total_templates ?? 0;

  return (
    <div className="ti-module">
      {/* Header */}
      <div className="ti-module-header">
        <div className="ti-module-title-block">
          <div className="ti-module-title-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7c5cfc" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </div>
          <div>
            <h1 className="ti-module-title">Template Intelligence</h1>
            <p className="ti-module-subtitle">Pattern matching engine for invoice fraud detection</p>
          </div>
        </div>
        <div className={`ti-engine-badge ${total > 0 ? 'active' : 'idle'}`}>
          <span className="ti-engine-dot" />
          {total > 0 ? `${total} Templates Active` : 'Engine Idle'}
        </div>
      </div>

      {/* Tab bar */}
      <div className="ti-tab-bar">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`ti-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="ti-tab-icon"><TabIcon id={tab.icon} /></span>
            <span className="ti-tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="ti-tab-body">
        {activeTab === 'overview'   && <OverviewTab stats={stats} onGoToUpload={() => setActiveTab('upload')} />}
        {activeTab === 'upload'     && <UploadTab onUploadSuccess={() => { onRefreshStats(); setActiveTab('database'); }} />}
        {activeTab === 'database'   && <DatabaseTab stats={stats} onRefresh={onRefreshStats} />}
        {activeTab === 'test-match' && <TestMatchTab />}
        {activeTab === 'config'     && <ConfigTab stats={stats} />}
      </div>
    </div>
  );
}
